import React, { useState} from "react";
import {
	Box,
	Button,
	Paper,
	Stack,
	styled,
	Tooltip,
	tooltipClasses,
	TooltipProps,
} from "@mui/material";
import {ICustomTabWindow} from "../interfaces/ICustomTabWindow";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {PentaSplit} from "../../../../components/common/PentaSplit";

interface IPanelStackProps {
	tabs: ICustomTabWindow[];
}

export const PanelStack: React.FC<IPanelStackProps> = (props) => {
	const [selectedTab, setSelectedTab] = useState(0);
	
	const Item = styled(Paper)(({theme}) => ({
		backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
		padding: theme.spacing(1),
		textAlign: "center",
	}));
	
	const LightTooltip = styled(({className, ...props}: TooltipProps) => (
		<Tooltip {...props} classes={{popper: className}}>{props.children}</Tooltip>
	))(({theme}) => ({
		[`& .${tooltipClasses.tooltip}`]: {
			backgroundColor: theme.palette.common.white,
			color: "rgba(0, 0, 0, 0.87)",
			boxShadow: theme.shadows[1],
			fontSize: 11,
		},
	}));
	
	return (
		<>
			<PentaSplit
				left={
					<Stack spacing={2} sx={{minWidth: "200px"}}>
						{props.tabs.map((tab, index) =>
							<Item
								style={{
									borderBottom: index === selectedTab ? "1px solid #3670c3" : "",
									color: index === selectedTab ? "#3670c3" : "",
									cursor: "pointer",
									alignItems: "center",
									justifyContent: "center",
									display: "flex"
								}}
								key={`stack-item-${index}`}
								onClick={() => setSelectedTab(index)}
							>{tab.icon}<span style={{marginLeft: "5px"}}>{tab.title}</span></Item>
						)}
					</Stack>
				}
				center={
					<Box sx={{backgroundColor: "#e6e6e6", p: 3, margin: 2, mt: 0, borderRadius: 3,}}>
						{selectedTab >= 0 && props.tabs.length > 0 && (
							<>
								<div style={{display: "flex", justifyContent: "space-between"}}>
									<div>
									</div>
									{props.tabs[selectedTab].actions &&
										<div>
											<LightTooltip
												title={(
													<>
														{props.tabs[selectedTab].actions?.map(it => {
															return (
																<Button fullWidth={true}
																	onClick={it.action}>{it.title}</Button>
															);
														})}
													</>
												)}
												sx={{width: "300px"}}
											>
												<MoreHorizIcon/>
											</LightTooltip>
										</div>
									}
								</div>
								{props.tabs[selectedTab].window}
								
							</>
						)}
					</Box>
				}
				
			/>
		</>
	);
};
